import React, { Component } from "react";
import moment from "moment";  
class TabHistory extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="tab" id="tab-document" ref="inner">
        <div className="table-responsive">
          <table className="table table-card table-card--ls mb-10">
            <thead>
              <tr>
                <th>Equipment</th>
                <th>Load</th>
                <th>Container #</th>
                <th>Driver</th>
                <th>Status</th>
                <th>Date</th>
                <th>From</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.chassisHistory.length===0 &&
                <tr>
                  <td colSpan={7}>
                    No Chassis History Available.
                  </td>
                </tr>
              }
              {this.props.chassisHistory.map((d) => {
                return (
                  <tr key={d._id}>
                    <td>{d.chassis ? d.chassis.chassisNo : ''}</td>
                    <td>
                      {d.load ? d.load.reference_number : ''}
                    </td>
                    <td>
                      {d.load ? d.load.containerNo : ''}
                    </td>
                    <td>
                      <div className="d-flex">
                        <div className="mr-2 align-self-center">
                          <div className="avatar-circle avatar-xs">
                            <div className="avatar-circle__initial ">K</div>
                          </div>
                        </div>
                        <h5 className="mb-0 align-self-center">
                          <a href="#" className="text-dark">
                            {d.driver && d.driver.name ? d.driver.lastName ? d.driver.name + " " + d.driver.lastName : d.driver.name : ''}
                          </a>
                        </h5>
                      </div>
                    </td>
                    <td>
                      <span className="badge badge-green">
                        {d.status ? d.status : ''}
                      </span>
                    </td>
                    <td>
                      <div>{d.date && moment(d.date).format('DD MMMM, YYYY')}</div>
                      <div className="text-muted">{d.date && moment(d.date).format('hh:mm a')}</div>
                    </td>
                    <td>{d.address ? d.address : ''}</td>
                  </tr>
                )
              })
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default TabHistory;
